import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "dua-auth-callback",
  templateUrl: "./auth-callback.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AuthCallbackComponent {}
